import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AlmamaterVisitDynamicAudit from './audit'
import { Image } from 'antd'

const AlmamaterVisitDynamicDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [dynamicDetail, setDynamicDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)

  const getDynamicDetail = () => {
    axios.post('/p/almamater_visit/dynamic/detail/get', {
      merchant_oid: merchantOid,
      dynamic_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setDynamicDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getDynamicDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (dynamicDetail.status.key === 2) return 'green'
    if (dynamicDetail.status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: dynamicDetail.oid,
      status: dynamicDetail.status.key,
      failureReason: dynamicDetail.failure_reason
    })
  }

  return (
    <Modal 
      title="动态详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡时间</div>
          <div className='public-datail-content'>{dynamicDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡人</div>
          <div className='public-datail-content'>{dynamicDetail.name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡团队</div>
          <div className='public-datail-content'>{dynamicDetail.team_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡行程</div>
          <div className='public-datail-content'>{dynamicDetail.itinerary_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡定位</div>
          <div className='public-datail-content'>{dynamicDetail.address}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>打卡照片</div>
          <div
            className="public-datail-photo"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'flex-start'
            }}
          >
            {dynamicDetail.photos && dynamicDetail.photos.length > 0 ? (
              <Image.PreviewGroup>
                {dynamicDetail.photos.map((url, index) => (
                  <Image
                    key={index}
                    src={url}
                    width={120}
                    style={{ marginRight: 8, marginBottom: 8 }}
                  />
                ))}
              </Image.PreviewGroup>
            ) : (
              <span style={{ color: '#999' }}>未上传照片</span>
            )}
          </div>
        </div>

        {dynamicDetail.status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{dynamicDetail.status.value}</div>
            <div className='public-datail-button' onClick={openAudit}>审核</div>
          </div>
        }
        {(dynamicDetail.status && dynamicDetail.status.key === 3) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>拒绝原因</div>
            <div className='public-datail-content'>{dynamicDetail.failure_reason || '未填写'}</div>
          </div>
        }
      </div>

      {isAuditVisible && <AlmamaterVisitDynamicAudit
        data={propsData}
        getDynamicDetail={getDynamicDetail}
        getAlmamaterVisitDynamicData={() => { props.getAlmamaterVisitDynamicData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
    </Modal>
  )
}

export default AlmamaterVisitDynamicDetail
